import React from 'react'
import "./Process.css"
import { TfiLayoutLineSolid } from "react-icons/tfi";
import Faq from '../Faq/Faq';
import Numbers from '../Numbers/Numbers';
import Consult from '../Consult/Consult';

const Process = () => {
    return (
        <div className='process-main' id='pro'>
            <div className="process-container">
                <div className="process-top">
                    <div className="process-head">
                        <span><TfiLayoutLineSolid />Getting Started</span>
                    </div>
                    <div className="process-title">
                        <span>From first call to first trade.</span>
                    </div>
                    <div className="process-p">
                        <p>A genuine sequence — this is the order clients actually move through.</p>
                    </div>
                </div>

                <div className="process-bottom">
                    <div className="p-bottom-1">
                        <span>Consultation</span>
                        <p>A no-obligation conversation about your goals and current holdings.</p>
                    </div>
                    <div className="p-bottom-1">
                        <span>Account setup</span>
                        <p>Paperless demat and trading account opening, handled end to end.</p>
                    </div>
                    <div className="p-bottom-1">
                        <span>Portfolio build</span>
                        <p>An allocation plan matched to your timeline and risk comfort.</p>
                    </div>
                    <div className="p-bottom-1">
                        <span>Ongoing advisory
                        </span>
                        <p>Regular reviews and rebalancing as markets and goals shift.</p>
                    </div>
                </div>
            </div>
            <Faq/>
            <Numbers/>
            <Consult/>
        </div>
    )
}

export default Process